import React from 'react';

function ResponsiveWebsitesSection() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdev-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="webdev-responsive-section">
      <div className="container webdev-responsive-container">
        {/* Left Column: Content */}
        <div className="webdev-responsive-left">
          <h2 className="webdev-responsive-title">
            Responsive Websites Build For<br />Your Business
          </h2>

          <p className="webdev-responsive-desc">
            At our website development company we are focused on cooperating with companies in managing their online presence by creating platforms that are both eye pleasing and fast forward in terms of functionality. A well-organized site is far greater than just a digital asset. It displays your company’s identity and professional image. Today, in the competitive market, users want web development agencies in Karachi that provide quick, user-friendly, and responsive web development services that strictly depend on their objectives. A responsive website adjusts smoothly to all devices and small screen sizes, providing customers with a consistent experience.
          </p>

          <p className="webdev-responsive-desc">
            Being one of the top website development companies across Pakistan, we follow precise deadlines, cutting-edge visual rules, and productive coding techniques. Companies frequently look for firms with a track record of success in post-launch support, technical consulting, and UX/UI. <a href="/" className="webdev-red-link">Expert Communication</a>, an experienced website development company, promises that every project is constructed for speed, security, and usefulness. Creating flexible websites with integrated performance features is something our developers are good at. Working with a leading web development company increases your prospects of digital growth and operational efficiency, regardless of whether your business is a service provider or a product based enterprise.
          </p>

          <button className="btn-webdev-discuss" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="webdev-responsive-right">
          <div className="webdev-responsive-img-wrapper">
            <img 
              src="/assets/images/web-dev/web-img1.png" 
              alt="Responsive Websites Build For Your Business - Expert Communication" 
              className="webdev-responsive-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResponsiveWebsitesSection;
